import gql from "graphql-tag";

export const CREATE_BACKLOG = gql`
  mutation createBacklog($workspaceId: ID) {
    createBacklog(workspaceId: $workspaceId) {
      _id
    }
  }
`;
